module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 31
// module chunks = 0